/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '../../../../app/shared/custom-alert/custom-alert.component';
const styles_CustomAlertComponent:any[] = ([] as any[]);
export const RenderType_CustomAlertComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_CustomAlertComponent,data:{}});
function View_CustomAlertComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),7,'button',[['class',
      'close'],['type','button']],(null as any),[[(null as any),'click'],[(null as any),
      'touch']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.onClose()) !== false);
      ad = (pd_0 && ad);
    }
    if (('touch' === en)) {
      const pd_1:any = ((<any>_co.onClose()) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i0.ɵeld(2,0,(null as any),(null as any),1,'span',[['aria-hidden','true']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['×'])),(_l()(),i0.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i0.ɵeld(5,0,(null as any),(null as any),1,'span',[['class','sr-only']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['Close'])),(_l()(),i0.ɵted(-1,(null as any),
          ['\n    ']))],(null as any),(null as any));
}
function View_CustomAlertComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),7,'div',[['class',
      'alert'],['role','alert']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),i0.ɵdid(1,278528,(null as any),0,i1.NgClass,[i0.IterableDiffers,
      i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,'klass'],ngClass:[1,
      'ngClass']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n    '])),(_l()(),
      i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CustomAlertComponent_2)),
      i0.ɵdid(4,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n    '])),
      i0.ɵncd((null as any),0),(_l()(),i0.ɵted(-1,(null as any),['\n  ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = 'alert';
    const currVal_1:any = _co.classes;
    _ck(_v,1,0,currVal_0,currVal_1);
    const currVal_2:any = _co.dismissible;
    _ck(_v,4,0,currVal_2);
  },(null as any));
}
export function View_CustomAlertComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted(-1,(null as any),['\n  '])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_CustomAlertComponent_1)),i0.ɵdid(2,
      16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n  ']))],(_ck,
      _v) => {
    var _co:i2.CustomAlertComponent = _v.component;
    const currVal_0:boolean = !_co.closed;
    _ck(_v,2,0,currVal_0);
  },(null as any));
}
export function View_CustomAlertComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'custom-alert',
      ([] as any[]),(null as any),(null as any),(null as any),View_CustomAlertComponent_0,
      RenderType_CustomAlertComponent)),i0.ɵdid(1,114688,(null as any),0,i2.CustomAlertComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const CustomAlertComponentNgFactory:i0.ComponentFactory<i2.CustomAlertComponent> = i0.ɵccf('custom-alert',
    i2.CustomAlertComponent,View_CustomAlertComponent_Host_0,{type:'type',dismissible:'dismissible',
        dismissOnTimeout:'dismissOnTimeout'},{close:'close'},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovU291cmNlL2VTb2Z0Q2VyZWFsLkFQSS9lU29mdENlcmVhbC5VSS9zcmMvYXBwL3NoYXJlZC9jdXN0b20tYWxlcnQvY3VzdG9tLWFsZXJ0LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9DOi9Tb3VyY2UvZVNvZnRDZXJlYWwuQVBJL2VTb2Z0Q2VyZWFsLlVJL3NyYy9hcHAvc2hhcmVkL2N1c3RvbS1hbGVydC9jdXN0b20tYWxlcnQuY29tcG9uZW50LnRzIiwibmc6Ly8vQzovU291cmNlL2VTb2Z0Q2VyZWFsLkFQSS9lU29mdENlcmVhbC5VSS9zcmMvYXBwL3NoYXJlZC9jdXN0b20tYWxlcnQvY3VzdG9tLWFsZXJ0LmNvbXBvbmVudC50cy5DdXN0b21BbGVydENvbXBvbmVudC5odG1sIiwibmc6Ly8vQzovU291cmNlL2VTb2Z0Q2VyZWFsLkFQSS9lU29mdENlcmVhbC5VSS9zcmMvYXBwL3NoYXJlZC9jdXN0b20tYWxlcnQvY3VzdG9tLWFsZXJ0LmNvbXBvbmVudC50cy5DdXN0b21BbGVydENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICA8ZGl2IGNsYXNzPVwiYWxlcnRcIiByb2xlPVwiYWxlcnRcIiBbbmdDbGFzc109XCJjbGFzc2VzXCIgKm5nSWY9XCIhY2xvc2VkXCI+XG4gICAgPGJ1dHRvbiAqbmdJZj1cImRpc21pc3NpYmxlXCIgdHlwZT1cImJ1dHRvblwiIGNsYXNzPVwiY2xvc2VcIiAoY2xpY2spPVwib25DbG9zZSgpXCIgKHRvdWNoKT1cIm9uQ2xvc2UoKVwiPlxuICAgICAgPHNwYW4gYXJpYS1oaWRkZW49XCJ0cnVlXCI+JnRpbWVzOzwvc3Bhbj5cbiAgICAgIDxzcGFuIGNsYXNzPVwic3Itb25seVwiPkNsb3NlPC9zcGFuPlxuICAgIDwvYnV0dG9uPlxuICAgIDxuZy1jb250ZW50PjwvbmctY29udGVudD5cbiAgPC9kaXY+XG4gICIsIjxjdXN0b20tYWxlcnQ+PC9jdXN0b20tYWxlcnQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O29CQ0VJO01BQUE7TUFBQTtJQUFBO0lBQUE7SUFBd0Q7TUFBQTtNQUFBO0lBQUE7SUFBb0I7TUFBQTtNQUFBO0lBQUE7SUFBNUU7RUFBQSxnQ0FBZ0c7TUFDOUY7VUFBQTtNQUF5Qix5Q0FBYztNQUN2QztVQUFBO01BQXNCLDZDQUFZO1VBQUE7OztvQkFIdEM7TUFBQTtNQUFBLHVCQUFBO2tEQUFBO01BQUEsMkJBQW9FLDhDQUNsRTthQUFBO2FBQUE7VUFBQSxpQ0FHUzthQUNULGtCQUF5Qjs7SUFMdEI7SUFBMkI7SUFBaEMsV0FBSyxVQUEyQixTQUFoQztJQUNVO0lBQVIsV0FBUSxTQUFSOzs7O29CQUZKLDRDQUNFO01BQUEsaUZBQUE7TUFBQTtVQUFBLHdCQU1NOzs7SUFOOEM7SUFBcEQsV0FBb0QsU0FBcEQ7Ozs7b0JDREY7TUFBQTtxQ0FBQSxVQUFBO01BQUE7SUFBQTs7Ozs7In0=



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/$$_gendir/app/shared/custom-alert/custom-alert.component.ngfactory.ts